import { filter, map } from "rxjs/operators";
import { mapEventTypeToPersistenceKey } from "../../../constants/mapEventTypeToPersistenceKey";
import { PlayerPreferencesPlatformType } from "../../../utils/network/generated/protoTypes";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionLeagueInfo, } from "../../info/league/actionPlayerLeagueInfo";
import { actionServerPersistenceSetInfo, } from "../actionServerPersistence";
var leagueInfoNeedsOverride = function (action) {
    var typeMatches = action.type === TypeActionLeagueInfo.Received;
    var isMapped = mapEventTypeToPersistenceKey.get(action.leagueId) !== undefined;
    var hasInfos = action.leagueInfo && action.leagueInfo.leagueId;
    if (typeMatches && isMapped && hasInfos) {
        var val = utilPersistence.getValue(mapEventTypeToPersistenceKey.get(action.leagueId));
        return val === Number.MAX_VALUE || val === undefined;
    }
    return false;
};
export var epicSetDefaultLeagueInfoKeys = function (action$, state$, deps) {
    return action$.pipe(filter(leagueInfoNeedsOverride), map(function (action) {
        var persistenceKey = mapEventTypeToPersistenceKey.get(action.leagueId);
        var valueToSet = {
            key: persistenceKey,
            platform: PlayerPreferencesPlatformType.PLAT_SHARED,
            value: action.leagueInfo.leagueId.toString(),
        };
        return actionServerPersistenceSetInfo(valueToSet);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/server-persistence/epics/epicSetDefaultLeagueInfoKeys.ts
// module id = 2328
// module chunks = 3